import React from 'react';
import Breadcrumbs from '@/widgets/breadcrumbs';
import EditSolicitationProvider from '../../components/apis/edit-solicitation-provider';
import EditSelectStandardItemWrapper from './sin-selection';
import { breadcrumbsPath } from '../../utils/solicitation-helpers';

const EditSolicitationSINSelection = () => {
  return (
    <div className="grid-col">
      <Breadcrumbs current="Edit Solicitation" path={breadcrumbsPath} />
      <EditSolicitationProvider step="sinSelect">
        <EditSelectStandardItemWrapper />
      </EditSolicitationProvider>
    </div>
  );
};

export default EditSolicitationSINSelection;
